/* eslint-disable key-spacing */
export const defaultMaskedInputTheme = {
  closeIcon:                'masked-input-clear-icon',
  input:                    'masked-input-element',
  inputWrapper:             'masked-input-wrapper',
  inputWrapperDisabled:     'disabled',
  inputWrapperFocused:      'focused',
  inputWrapperInvalid:      'danger',
  inputWrapperRequired:     'required',
  wrapper:                  'masked-wrapper',
};
